import type { Step } from "react-joyride";

export const auditRecordFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ/ແກ້ໄຂບັນທຶກການກວດສອບ! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີຕື່ມຂໍ້ມູນບັນທຶກການກວດສອບໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="record-form-auditor"]',
    content:
      "ເລືອກຜູ້ກວດສອບ. ທ່ານສາມາດເລືອກຜູ້ກວດສອບຈາກລາຍການ. ຜູ້ກວດສອບປັດຈຸບັນຈະຖືກເລືອກໂດຍອັດຕະໂນມັດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-form-date"]',
    content:
      "ເລືອກວັນທີກວດສອບ. ນີ້ຈະກຳນົດວັນທີທີ່ດຳເນີນການກວດສອບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-form-items"]',
    content:
      "ຕື່ມລາຍການກວດສອບ. ທ່ານຈະຕື່ມລາຍການກວດສອບແຕ່ລະລາຍການ, ກຳນົດຜົນການກວດສອບ (ຜ່ານ/ບໍ່ຜ່ານ/ຕ້ອງປັບປຸງ), ແລະເພີ່ມໝາຍເຫດຖ້າຈຳເປັນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="record-form-submit"]',
    content:
      "ຫຼັງຈາກຕື່ມຂໍ້ມູນທັງໝົດແລ້ວ, ທ່ານສາມາດບັນທຶກເປັນຮ່າງ ຫຼືບັນທຶກແລະສຳເລັດ. ບັນທຶກທີ່ສຳເລັດແລ້ວບໍ່ສາມາດແກ້ໄຂໄດ້.",
    placement: "top",
  },
];

